import { ROUTES } from '@/constants/routes';
import { Status } from '@/types/common';
import { useNavigate } from 'react-router-dom';
import { StaffMemberListItem } from '@/types/staff';
import { SVListItemCard } from '../core';

type StaffListProps = {
  staffList: StaffMemberListItem[];
};

export default function StaffList({ staffList }: StaffListProps) {
  const navigate = useNavigate();

  return (
    <>
      {staffList.map(staff => {
        const { uuid, avatar, fullName, status, email, totalActiveCompanies } =
          staff;

        return (
          <SVListItemCard
            onClick={() => navigate(`${ROUTES.STAFF}/${uuid}`)}
            avatar={avatar}
            showAvatar
            key={uuid}
            header={fullName}
            status={status}
            statusType="standard"
            manageMenuItems={
              status === Status.ACTIVE
                ? [
                    {
                      label: 'Edit',
                      onClick: () =>
                        navigate(`${ROUTES.STAFF_EDIT_PARAMS}/${uuid}`),
                    },
                    {
                      label: 'View Companies',
                      onClick: () =>
                        navigate(`${ROUTES.COMPANIES}?staffId=${uuid}`),
                    },
                  ]
                : [
                    {
                      label: 'Reactivate',
                      onClick: () =>
                        navigate(`${ROUTES.STAFF_EDIT_PARAMS}/${uuid}`),
                    },
                  ]
            }
            additionalInfo={[
              {
                label: 'Email',
                text: email,
              },
              {
                label: 'Companies',
                text: totalActiveCompanies,
              },
            ]}
          />
        );
      })}
    </>
  );
}
